import { Layout, Typography, Row, Col, Form, Input, Card, Select } from "antd";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/custom/CustomButton";
import { useEffect, useState } from "react";
const { Text } = Typography;

const EditbranchTypeForm = ({
  allowedPaymentTypeData,
  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
  selectedBranchTypeKey,
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [allowedStatus, setAllowedStatus] = useState(0);
  const totalOptions = allowedPaymentTypeData?.length || 0;

  useEffect(() => {
    getBranchTypeById(selectedBranchTypeKey.id);
  }, []);

  const onCancel = () => {
    navigate("/sya0300", { replace: false });
  };

  const onValuesChange = (_, allValues) => {
    const selected = allValues.allowedPaymentTypes || [];
    if (selected.length === 0) {
      setAllowedStatus(0);
    } else if (selected.length === totalOptions) {
      setAllowedStatus(1);
    } else {
      setAllowedStatus(2);
    }
  };

  const getBranchTypeById = (id) => {
    const url = `${apiConfig.Officetype}/${id}?template=true`;
    const body = { session };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const selected =
          res?.configuredPaymentTypes?.map((item) => item.id) || [];

        form.setFieldsValue({
          name: res?.name || "",
          allowedPaymentTypes: selected,
        });

        // Wait for allowedPaymentTypeData to load properly
        if (allowedPaymentTypeData && allowedPaymentTypeData.length > 0) {
          if (selected.length === 0) {
            setAllowedStatus(0);
          } else if (
            selected.length === allowedPaymentTypeData.length &&
            selected.every((id) =>
              allowedPaymentTypeData.some((opt) => opt.value === id)
            )
          ) {
            setAllowedStatus(1); // All
          } else {
            setAllowedStatus(2); // Partial
          }
        }

        setIsLoading(false);
      }
    });
  };

  const handleSubmit = (values) => {
    const payload = {
      name: values.name,
      paymentTypes: values.allowedPaymentTypes,
      allowedPaymentTypes: allowedStatus,
    };

    const body = {
      ...payload,
      method: "PUT",
      session,
      locale: "en",
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      `${apiConfig.Officetype}/${selectedBranchTypeKey.id}`,
      (err, res) => {
        setIsLoading(false);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Branch Type Updated Successfully");

          navigate("/sya0300", { replace: false });
        }
      }
    );
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ paddingTop: 20 }}
      onFinish={handleSubmit}
      onValuesChange={onValuesChange}
    >
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        title="Edit Branch Type"
      >
        <Card
          style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
        >
          <Row gutter={24} style={{ justifyContent: "space-between" }}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="name"
                label={<Text strong>Name</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input placeholder="Enter Branch Name" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="allowedPaymentTypes"
                label={<Text strong>Allowed Payment Types</Text>}
              >
                <Select
                  mode="multiple"
                  showSearch
                  placeholder="Select Options"
                  options={allowedPaymentTypeData}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Form.Item>
          <Row>
            <CustomButton
              content="Submit"
              htmlType="submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={onCancel}
            />
          </Row>
        </Form.Item>
      </Card>
    </Form>
  );
};

export default EditbranchTypeForm;
